import { createSelector } from 'reselect';
import { isNaN, toNumber } from 'lodash/fp';

import { getAgrBracketFromAges } from '../select-age-bracket';
import AgrService from '../../models/agr';
import getIncomeTierOptions from '../../utils/get-income-tier-options';
import selectRawPrice from '../select-raw-price';

// @ts-expect-error - Automatic, Please fix when editing this file
const selectCustomerFormValues = (state, values) => values;

export default createSelector([selectCustomerFormValues, selectRawPrice], (customerFormValues, rawPrice) => {
  const { age, incomeTier, incomeType, partnerAge } = customerFormValues;
  const ageBracket = getAgrBracketFromAges({ client: age, spouse: partnerAge });

  const incomeTierAsNumber = toNumber(incomeTier);
  if (isNaN(incomeTierAsNumber)) {
    return 0;
  }

  const incomeTierOption = getIncomeTierOptions({ incomeType })[incomeTierAsNumber];
  if (!incomeTierOption) {
    return 0;
  }

  const { value } = incomeTierOption;

  return AgrService.getPercentage(
    {
      ageBracket,
      incomeTier: value,
      rebate: true,
    },
    {
      useFutureEffectiveDate: rawPrice?.useFutureEffectiveDate,
    },
  );
});
